const axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-XSRF-TOKEN'] = document.querySelector(`meta[name="csrf_token"]`)?.value;


window.IslandCart = window.IslandCart || {};

const unwrap = ({data}) => data;

class API {
    version = 'v1';
    _path = [];
    constructor(path = [], methods = {}){
        this.path = `api`;
        this.path = this.version;
        if(path.length){
            this._path.push(...path);
        }
        if( methods ){
            Object.assign(this, methods);
        }
    }

    get path(){
        return '/' + this._path.join('/');
    }
    set path(part){
        this._path.push(part);
        return this.path;
    }

    async get(id){
        this.path = id;
        return axios.get(this.path).then(unwrap);
    }
    async store(data){
        return axios.post(this.path, data).then(unwrap);
    }
    async update(id, data){
        this.path = id;
        data._method = 'put';
        return axios.post(this.path, data).then(unwrap);
    }
    async delete(id){
        this.path = id;
        data._method = 'delete';
        return axios.post(this.path).then(unwrap);
    }
    async query(params){
        return axios.get(this.path, {params}).then(unwrap);
    }
}

IslandCart.api = new API([], {
    account: () => new API(['account'], {
        addresses: () => new API(['account', 'addresses'], {
            defaults: () => new API(['account', 'addresses', 'defaults'])
        }),
        wishlist: () => ({
            add: (product) => axios.get(`/account/wishlist/add?product=${product}`).then(unwrap),
            remove: (product) => axios.get(`/account/wishlist/remove?product=${product}`).then(unwrap),
        }),
        paymentOptions: () => new API(['account', 'payment-options'])
    }),
    cart: () => ({
        // the two thens are because the axios AND the api wrap each of their responses with a data key
        get: () => axios.get('/cart?ajax').then(unwrap).then(unwrap),
        add: (payload) => axios.post('/cart/add?ajax', payload).then(unwrap).then(({data, errors}) => ({data, errors})),
        remove: (payload) => axios.post('/cart/remove?ajax', payload).then(unwrap).then(unwrap),
    }),
    countries: () => new API(['countries']),
    locations: () => new API(['locations'], {
        get: async function(id = null) {
            return axios.get(this.path, {withCredentials: true}).then(unwrap).then(data => {
                if(id !== null) return new Location(data);
                return data.map(l => new Location(l));
            });
        },
        choose: async function(location_code) {
            return axios.get(`${this.path}/choose/${location_code}`, {withCredentials: true}).then(unwrap);
        },
        clear: async function() {
            return axios.get(`${this.path}/clear`, {withCredentials: true}).then(unwrap);
        },
        pickupTime: async function(pickup_time) {
            return axios.get(`${this.path}/pickup-time?pickup_time=${pickup_time}`, {withCredentials: true}).then(unwrap);
        },
        clearPickupTime: async function() {
            return axios.get(`${this.path}/pickup-time/clear`, {withCredentials: true}).then(unwrap);
        }
    }),
    products: () => new API(['products']),
    alerts: () => new API(['alerts'], {
        dismiss: (alert_id) => axios.get(`/alerts/dismiss/${alert_id}`, {withCredentials: true}).then(unwrap),
    }),
});

class Location {
    constructor(data = {}){
        Object.assign(this, data);
    }
    // re render times based on location hours for the selected day. the component gives us the day in ISO format
    // const day = (new Date(`${event.detail.date}T00:00`)).toLocaleString('en-US', { weekday: 'short' }).toLowerCase();
    // const hours = location_hours.find(h => h.day === day);

    hoursForDate(date){
        if (!(date instanceof Date)) date = new Date(date);
        const day = date.toLocaleString('en-US', { weekday: 'short' }).toLowerCase();
        return this.hours.find(h => h.day === day);
    }

    todaysHours(){
        return this.hoursForDate(new Date());
    }
}

class Cart {
    items = [];
    discounts = [];

    _onload = [];

    constructor(){
        (window.location.pathname != '/checkout') && this.refresh();
    }

    hasAPI(){
        if (!IslandCart.api) throw Error('Cannot access IslandCart API!');
    }

    refresh(){
        this.hasAPI();

        return IslandCart.api.cart().get().then(data => {
            this.items = data.items;
            this.fees = data.fees;
            this.discounts = data.applied_discounts;

            this.is_pickup = data.is_pickup ?? false;
            this.pickup_time = data.pickup_time ?? null;
            this.location = data.location ? new Location(data.location) : null;
            this.store_location_id = data.store_location_id ?? null;

            this._onload.forEach(cb => cb.bind(this)(this));
            this._onload = [];

            return data;
        })
    }

    set onload(cb){
        if( typeof cb !== 'function') throw Error('Cart.onload must be a function');
        this._onload.push(cb);
    }

    get total() {
        let total = 0;
        total = this.items.reduce((item, agg) => agg + item.total, total);
        total = this.discounts.reduce((disc, agg) => agg - disc.discount_amount, total);
        return total
    }

    get subtotal() {
        let sub = 0;
        sub = this.items.reduce((item, agg) => agg + item.total, sub);
        return sub;
    }

    increment(item_id, num = 1){
        this.hasAPI();
        let line_item = this.items.find(item => item.id == item_id);

        return IslandCart.api.cart().add({product: line_item.product.code, quantity:num});
    }

    remove(item_id){
        this.hasAPI();
        let line_item = this.items.find(item => item.id == item_id);

        return IslandCart.api.cart().remove({product: line_item.product.code});
    }
}

IslandCart.cart = new Cart();


class Checkout {
    billing_address = {
        first_name: null,
        last_name: null,
        street: null,
        street_2: null,
        city: null,
        state: null,
        zip: null,
        country: null,
    };
    shipping_address = {
        first_name: null,
        last_name: null,
        street: null,
        street_2: null,
        city: null,
        state: null,
        zip: null,
        country: null,
    };
    shipping_method = {
        name: null,
        rate: null,
    };
    billing_is_shipping = true;

    get shipping_address(){
        if(this.billing_is_shipping){
            return this.billing_address;
        }
        return this.shipping_address;
    }

    toggleShipping(){
        this.billing_is_shipping = !this.billing_is_shipping;
    }

    message(message = null, status = 'light', delay = null){
        let wrapper = document.getElementById('basket-message');
        wrapper.innerHTML = message ? `<div class="alert alert-${status}">${message}</div>` : '';

        if( delay !== null ){
            setTimeout(() => {
                wrapper.firstElementChild.remove();
            }, delay)
        }
    }

    resize(){
		const height = document.body.scrollHeight;
		const width =  document.body.scrollWidth;
		window.parent.postMessage({
			height,
			width
		}, '*');
    }

    submitAsync(payload = {}){
        let data = new FormData(window.parent.document.getElementById('checkout-form'));
        data.append('payload', JSON.stringify(payload));

        return axios.post('/checkout/callback', data, {
                validateStatus: (status) => (status >= 200 && status < 300) || (status >= 400 && status < 500), 
            })
            .then(({data}) => data);
    }

    submit(formOrFormDataOrPayload){
        let main_form = window.top.document.getElementById('checkout-form');
        let payload = {};

        if(formOrFormDataOrPayload instanceof FormData){
            payload = Object.fromEntries(formOrFormDataOrPayload.entries());
        } else if(formOrFormDataOrPayload instanceof HTMLFormElement){
            payload = Object.fromEntries(new FormData(formOrFormDataOrPayload).entries());
        } else if(typeof formOrFormDataOrPayload === 'object'){
            payload = formOrFormDataOrPayload;
        } else {
            throw Error('Invalid argument passed to Checkout.submit');
        }

        for(let key in payload){
            let input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = payload[key];
            main_form.appendChild(input);
        }

        main_form.submit();
    }
}

IslandCart.checkout = new Checkout();

// Convert a nested object to a flattened dotified object ie:
/*
    {
        cart: {
            user: {
                name: 'John Doe'
            }
            product: {
                options: ['red', 'blue']
            },
        }
    }
    =>
    
    {
        'cart.user.name': 'John Doe',
        'cart.product.options.0': 'red',
        'cart.product.options.1': 'blue',
    }
*/

IslandCart.dotify = function (dottable){
    let dotified = [];

    function recurse(node, path = []){
        for(let key in node){
            let newPath = [...path, key];
            if(node[key] && typeof node[key] === 'object'){
                recurse(node[key], newPath);
            } else if (typeof node[key] !== 'function'){
                dotified[newPath.join('.')] = node[key];
            }
        }
        return;
    }

    recurse(dottable);

    return dotified;
}

IslandCart.forms = {
    // take an input name like product[options][0] and return "product.options.0"
    dotName: name => name.replace(/\[\]/g, '*').replace(/\[/g, '.').replace(/\]/g, ''),
    // take a dotified name like product.options.0 and return product[options][0]
    htmlName: name => name.split('.').reduce((acc, part) => acc == '' ? part : acc + `[${part}]`, '').replace(/\[\*\]/g, '[]'),
    hydrate: function(context, data){
        const dotted = IslandCart.dotify(data);

        for(let key in dotted){
            let input = context.querySelector(`[name="${IslandCart.forms.htmlName(key)}"]`);
            if(input) input.value = dotted[key];
        }
    },
};